import classNames from 'classnames'

import style from './style.scss'

type Props = {
  small?: boolean
} & React.HTMLAttributes<HTMLParagraphElement>

function Paragraph({ className, small = false, ...rest }: Props) {
  return (
    <p
      className={classNames(
        style.wrapper,
        {
          [style.small]: small,
        },
        className,
      )}
      {...rest}
    />
  )
}

export default Paragraph
